export const MeterNotReportingTroubleshooting = () =>
    <div className="font-normal text-sm p-3 bg-blue-50 rounded">
        <h4 className="font-semibold">
            For efficient resolution of any system issues, please follow these steps:
        </h4>
        <ul className="mt-4 list-decimal pl-5">
            <li>
                <span className="font-semibold">Log into</span> the <span className="font-semibold">Enphase
                    Enlighten Portal</span> at <a
                    href="https://enlighten.enphaseenergy.com/"
                    target="_blank"
                    rel="noreferrer"
                >https://enlighten.enphaseenergy.com/</a>, <span className="font-semibold">select</span> the
                warranty holder's site from the <span className="font-semibold">systems
                    list</span>, and <span className="font-semibold">navigate</span> to
                the <span className="font-semibold">Devices tab</span> to see device details.
            </li>
            <li>
                <span className="font-semibold">Work with</span> the warranty holder to remotely confirm if the USB
                ZigBee radio stick is properly inserted.
            </li>
            <li>
                <span className="font-semibold">Power cycle</span> the Gateway
                and <span className="font-semibold">check system status</span> after 15 minutes.
            </li>
            <li>
                <span className="font-semibold">Install</span> a repeater if signal issues persist, per
                the <span className="font-semibold">RGM Manual</span>.
            </li>
        </ul>
    </div>
